import React from 'react'

function Androidapp() {
  return (
    <div>
      {/* Hero Start */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 pt-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start">
              <h1 className="display-4 text-white mb-4 animated slideInRight">Android App Development</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/index">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Android App</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Bluevipers Technology specializes in creating powerful, user-friendly Android applications tailored to your business needs. 
                From concept to deployment, we deliver apps that are fast, secure, and scalable.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="Android App" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>
      {/* Hero End */}

      {/* Feature Start */}
      <div className="container-fluid bg-dark feature pt-5">
        <div className="container pt-5">
          <div className="row g-5">
            <div className="col-lg-12 align-self-center mb-md-5 pb-md-5 wow fadeIn" data-wow-delay="0.3s">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Why Choose Our Apps</div>
              <h1 className="text-white mb-4">Professional Android Apps with Excellent UX</h1>
              <p className="text-light mb-4">
                We develop Android applications that are intuitive, feature-rich, and designed to engage users. 
                Our apps integrate latest technologies, ensuring fast performance and seamless functionality.
              </p>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Custom App Development</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>User-Friendly Design</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Secure & Scalable Solutions</span>
              </div>
             
            </div>
          
          </div>
        </div>
      </div>
      {/* Feature End */}

      {/* Contact Section */}
      <div className="container-fluid bg-primary py-5">
        <div className="container text-center">
          <h2 className="text-white mb-4">Contact Us for Your Android App</h2>
          <p className="text-white-50 mb-2">
            Call us at <strong>+91 8459432930</strong>
          </p>
          <p className="text-white-50 mb-4">
            Email: <strong>blueviperstechnology@gmail.com</strong>
          </p>
          <a href="/contact" className="btn btn-light rounded-pill px-4 py-2">Contact Now</a>
        </div>
      </div>
      {/* Contact Section End */}
    </div>
  )
}

export default Androidapp
